// selectors/authSelectors.js

export const getData = (state) => state.collaborator.data;
export const getLoading = (state) => state.collaborator.loading;
export const getError = (state) => state.collaborator.error;
